import { render, staticRenderFns } from "./cargo_pets.vue?vue&type=template&id=698b0f8c&"
import script from "./cargo_pets.vue?vue&type=script&lang=js&"
export * from "./cargo_pets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports